import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

// import {formatDropdownData} from '../../../../../utils/formatting';
// import * as locations from '../../../../../constants/locations';
import {formatQuerystring} from '../../../../../utils/formatting';

import * as productActionCreators from '../../../../../actions/product';
let allActionCreators = Object.assign({}, productActionCreators);

// import RhinoSelect from '../../../../common/inputs/RhinoSelect';

class ResultsPagination extends React.Component {

  static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  incrementPage() {
    if(this.props.isDiamondPage) {
      // get more diamonds
    }
    this.props.pageNext();

    // if(this.props.isDiamondPage) {

    //   this.props.productAddDiamonds(formatQuerystring(this.props.product.diamondFilters), this.props.product.currentDiamondPage + 1)
    //   .then((respData) => {
    //     this.props.productAddDiamondResults(respData.results);
    //   });
    // }
  }

  // TODO: add setpage method

  // TODO: add increment diamond method

  pageNav(newPage) {

    this.props.setPage(parseInt(newPage));
    // if(this.props.isDiamondPage && newPage > (this.props.pageNum + 1)) {

    //   this.props.productAddDiamonds(formatQuerystring(this.props.product.diamondFilters), this.props.product.currentDiamondPage + 1)
    //   .then((respData) => {
    //     this.props.productAddDiamondResults(respData.results);
    //   });
    // }
  }

  renderLHS() {

    if(this.props.pageNum === 1) {
      return <div className='pageLHS'></div>;
    }

    if(this.props.pageNum == 2) {
      return <div className='pageLHS'>
        <div className='pageClickable' onClick={() => this.props.setPage(1)}>1</div>
      </div>;
    }

    if(this.props.pageNum == 3) {
      return <div className='pageLHS'>
        <div className='pageClickable' onClick={() => this.props.setPage(1)}>1</div>
        <div className='pageClickable' onClick={() => this.props.setPage(2)}>2</div>
      </div>;
    }

    if(this.props.pageNum == 4) {
      return <div className='pageLHS'>
        <div className='pageClickable' onClick={() => this.props.setPage(1)}>1</div>
        <div className='pageClickable' onClick={() => this.props.setPage(2)}>2</div>
        <div className='pageClickable' onClick={() => this.props.setPage(3)}>3</div>
      </div>;
    }

    if(this.props.pageNum >= 5) {
      return <div className='pageLHS'>
        <div className='pageClickable' onClick={() => this.props.setPage(1)}>1</div>
        <div className='pageElipsis'>&#8230;</div>
        <div className='pageClickable' onClick={() => this.props.setPage(parseInt(this.props.pageNum) - 1)}>{parseInt(this.props.pageNum) - 1}</div>
      </div>;
    }
  }

  renderRHS() {

    let pageDiff = this.getNumberOfPages() - this.props.pageNum;

    if(pageDiff > 3) {
      return <div className='pageRHS'>
        <div className='pageClickable' onClick={() => this.pageNav(this.props.pageNum + 1)}>{this.props.pageNum + 1}</div>
        <div className='pageElipsis'>&#8230;</div>
        <div className='pageClickable' onClick={() => this.pageNav(this.getNumberOfPages())}>{this.getNumberOfPages()}</div>
      </div>;
    } else {
      return <div className='pageRHS'>
        {this.props.pageNum + 1 <= this.getNumberOfPages() ?
          <div className='pageClickable' onClick={() => this.pageNav(this.props.pageNum + 1)}>{this.props.pageNum + 1}</div> :
          null
        }
        {this.props.pageNum + 2 <= this.getNumberOfPages() ?
          <div className='pageClickable' onClick={() => this.pageNav(this.props.pageNum + 2)}>{this.props.pageNum + 2}</div> :
          null
        }
        {this.props.pageNum + 3 <= this.getNumberOfPages() ?
          <div className='pageClickable' onClick={() => this.pageNav(this.props.pageNum + 3)}>{this.props.pageNum + 3}</div> :
          null
        }
      </div>;
    }
  }

  renderDiamondRHS() {
    return <div className='pageRHS'>
      {this.props.pageNum + 1 <= this.getNumberOfPages() ?
        <div className='pageClickable' onClick={() => this.pageNav(this.props.pageNum + 1)}>{this.props.pageNum + 1}</div> :
        null
      }
      {this.props.pageNum + 2 <= this.getNumberOfPages() ?
        <div className='pageClickable' onClick={() => this.pageNav(this.props.pageNum + 2)}>{this.props.pageNum + 2}</div> :
        null
      }
      {this.props.pageNum + 3 <= this.getNumberOfPages() ?
        <div className='pageClickable' onClick={() => this.pageNav(this.props.pageNum + 1)}>&gt;</div> :
        null
      }
    </div>;
  }

  getNumberOfPages() {

    if(this.props.isDiamondPage === true) {

      if(!this.props.product.diamondResultsCount) {
        return 1;
      }
      return Math.ceil(parseInt(this.props.product.diamondResultsCount) / parseInt(this.props.pageSize));
    
    } if(this.props.isSearchPage === true) {    
      
      if(!this.props.searchItems) {
        return 1;
      }
      return Math.ceil(parseInt(this.props.searchItems.length) / parseInt(this.props.pageSize));        

    } else {

      if(!this.props.product.productResultsCount) {
        return 1;
      }
      return Math.ceil(parseInt(this.props.product.productResultsCount) / parseInt(this.props.pageSize));
    }
  }

  render() {

    // console.log('pageination');
    // console.log(this.props.resultCount);
    // console.log(this.props.pageSize);
    // console.log(this.props.pageNum);
    // console.log(this.props.pageSize * this.props.pageNum);

    return <div className='ResultsPagination'>
      {this.props.pageNum > 1 ?
        <div className='prevPageWrapper' onClick={::this.props.pagePrev}>&lt; Previous</div> :
        null
      }
      <div className='pageLabelWrapper'>
        <div className='pageLabelLHS'>{this.renderLHS()}</div>
        <div className='pageLabelCenter'>{!isNaN(this.props.pageNum) ? this.props.pageNum : 1}</div>
        {this.props.isDiamondPage ?
          <div className='pageLabelRHS'>{this.renderDiamondRHS()}</div> :
          <div className='pageLabelRHS'>{this.renderRHS()}</div>
        }
      </div>
      {this.props.pageNum < this.getNumberOfPages() ?
        <div className='nextPageWrapper' onClick={::this.incrementPage}>Next &gt;</div> :
        null
      }
    </div>;
  }
}
export default ResultsPagination;

function mapStateToProps(state) {
  return {
    product: state.product,
  };
}

export const ResultsPaginationContainer = connect(
  mapStateToProps,
  allActionCreators
)(ResultsPagination);


// WEBPACK FOOTER //
// ./src/components/views/gallery/blocks/results/ResultsPagination.jsx